import React from 'react';
import { AssetUrls } from 'config/assets';

interface FeedZeroStateProps {
  headline?: string;
  subtext?: string;
}

export const FeedZeroState: React.FC<FeedZeroStateProps> = ({
  headline = 'Nothing traded yet.',
  subtext = 'Check back soon — the community is warming up.',
}) => (
  <div className="feed-zero-state">
    <img
      src={AssetUrls.logos.arevakhachIcon}
      alt="TradeMagic"
      className="feed-zero-state__logo"
    />
    <h2 className="feed-zero-state__headline">{headline}</h2>
    <p className="feed-zero-state__subtext">{subtext}</p>
  </div>
);

export default FeedZeroState;
